/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Use_Land_Skin_TitleInputs */

const en_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply Your New Land Style?`)
};

const ar_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل تريد تطبيق نمط الأرض الجديد؟`)
};

const de_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Land-Stil anwenden?`)
};

const es_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Aplicar tu nuevo estilo de terreno?`)
};

const fr_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer votre nouveau style de sol ?`)
};

const it_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applicare il nuovo stile del terreno?`)
};

const ja_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいランドスタイルを使いますか？`)
};

const ko_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 랜드 스타일을 적용할까요?`)
};

const pt_br_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar seu novo estilo de terreno?`)
};

const ru_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить новый стиль земли?`)
};

const th_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้สไตล์พื้นดินใหม่ไหม?`)
};

const tr_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni arazi türü uygulansın mı?`)
};

const zh_cn_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用新土地皮肤？`)
};

const zh_tw_dialog_use_land_skin_title = /** @type {(inputs: Dialog_Use_Land_Skin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`套用新土地造型？`)
};

/**
* | output |
* | --- |
* | "Apply Your New Land Style?" |
*
* @param {Dialog_Use_Land_Skin_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_use_land_skin_title = /** @type {((inputs?: Dialog_Use_Land_Skin_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Use_Land_Skin_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_use_land_skin_title(inputs)
	if (locale === "ar") return ar_dialog_use_land_skin_title(inputs)
	if (locale === "de") return de_dialog_use_land_skin_title(inputs)
	if (locale === "es") return es_dialog_use_land_skin_title(inputs)
	if (locale === "fr") return fr_dialog_use_land_skin_title(inputs)
	if (locale === "it") return it_dialog_use_land_skin_title(inputs)
	if (locale === "ja") return ja_dialog_use_land_skin_title(inputs)
	if (locale === "ko") return ko_dialog_use_land_skin_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_use_land_skin_title(inputs)
	if (locale === "ru") return ru_dialog_use_land_skin_title(inputs)
	if (locale === "th") return th_dialog_use_land_skin_title(inputs)
	if (locale === "tr") return tr_dialog_use_land_skin_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_use_land_skin_title(inputs)
	return zh_tw_dialog_use_land_skin_title(inputs)
});